import React, { useState } from 'react';
import Swal from 'sweetalert2';
import classroomService from '../../services/classroomService';
import utils from '../../utils/generalFunctions';

// Formulario de un intervalo (Semana 1-10, Bimestre 1, o el nombre que el
// docente quiera). interval=null crea uno nuevo dentro de classroomId.
const ClassroomIntervalForm = ({ classroomId, interval, onClose }) => {
    const initData = {
        intervalId: interval?.intervalId || 0,
        classroomId,
        name: interval?.name || '',
        startDate: interval?.startDate ? interval.startDate.substring(0, 10) : '',
        endDate: interval?.endDate ? interval.endDate.substring(0, 10) : '',
        orden: interval?.orden ?? 0,
        isVisible: interval?.isVisible ?? false,
        isActive: interval?.isActive ?? true
    };
    const [formData, setFormData] = useState(initData);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name) {
            Swal.fire('Campo obligatorio', 'El nombre del intervalo es obligatorio.', 'error');
            return;
        }
        const user = utils.getUserInformation();
        const payload = { ...formData, createdUser: user?.userId, modificationUser: user?.userId };
        try {
            // El backend devuelve el registro ya confirmado en la base de
            // datos (con su intervalId real y valores por defecto
            // aplicados) — se lo pasamos al padre para que actualice el
            // estado local sin tener que volver a pedir todo el árbol.
            const guardado = formData.intervalId > 0
                ? await classroomService.updateInterval(payload)
                : await classroomService.createInterval(payload);
            Swal.fire('Listo', 'Intervalo guardado con éxito.', 'success');
            if (onClose) onClose(guardado);
        } catch (error) {
            console.error(error);
            Swal.fire('Ha ocurrido un error', 'Por favor intentelo más tarde', 'error');
        }
    };

    return (
        <form onSubmit={handleSubmit} className="container-fluid mt-2">
            <div className="mb-3">
                <label className="form-label">Nombre del intervalo *</label>
                <input
                    type="text"
                    className="form-control"
                    name="name"
                    placeholder='Ej: "Semana 1-10", "Bimestre 1"...'
                    value={formData.name}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="row">
                <div className="col-md-6 mb-3">
                    <label className="form-label">Fecha inicio</label>
                    <input type="date" className="form-control" name="startDate" value={formData.startDate} onChange={handleChange} />
                </div>
                <div className="col-md-6 mb-3">
                    <label className="form-label">Fecha fin</label>
                    <input type="date" className="form-control" name="endDate" value={formData.endDate} onChange={handleChange} />
                </div>
            </div>
            <div className="mb-3">
                <label className="form-label">Orden</label>
                <input type="number" className="form-control" name="orden" value={formData.orden} onChange={handleChange} />
            </div>
            <div className="form-check mb-3">
                <input type="checkbox" className="form-check-input" id="intervalVisible" name="isVisible" checked={formData.isVisible} onChange={handleChange} />
                <label className="form-check-label" htmlFor="intervalVisible">Visible para los estudiantes</label>
            </div>
            <button type="submit" className="btn btn-primary">Guardar</button>
        </form>
    );
};

export default ClassroomIntervalForm;
